"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _chunkR624SQFFjs = require('./chunk-R624SQFF.js');


var _chunkQ4G2SZRDjs = require('./chunk-Q4G2SZRD.js');

// src/question-model/types/base.ts
var Question = class {
  constructor(state, previousState) {
    this.state = state;
    this.normalize();
    if (previousState) {
      this.updateStateFromPreviousState(previousState);
    }
  }
  showError() {
    this.state.errorVisible = true;
  }
  hideError() {
    this.state.errorVisible = false;
  }
  getState() {
    return this.state;
  }
  validate() {
    return null;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  updateStateFromPreviousState(_previousState) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  normalize() {
    this.validate();
    return this.state;
  }
};

// src/question-model/types/text.ts
var i18n2 = _chunkR624SQFFjs.i18n.call(void 0, ["questionModel"]);
var Text = class extends Question {
  getValue() {
    return this.state.value || "";
  }
  setValue(value) {
    this.state.value = value;
    this.validate();
  }
  resetValue() {
    this.state.value = "";
    this.validate();
  }
  getAnswerText() {
    return this.getValue();
  }
  getValueAsObj() {
    return { text: this.getValue() };
  }
  // eslint-disable-next-line max-statements
  validate() {
    const isRequired = this.state.required;
    const { state } = this;
    state.errors = [];
    state.isValid = true;
    const value = this.getValue().trim();
    if (isRequired && !value) {
      state.errors.push(i18n2(["requiredField"]));
      state.isValid = false;
      return state.errors;
    }
    if (this.state.charLimit && value.length > this.state.charLimit) {
      state.errors.push(i18n2(["maxLenghtExceeded"]));
      state.isValid = false;
      return state.errors;
    }
    return null;
  }
  updateStateFromPreviousState(previousState) {
    super.updateStateFromPreviousState(previousState);
    this.state.value = previousState.value;
  }
};

// src/question-model/types/radio.ts
var i18n3 = _chunkR624SQFFjs.i18n.call(void 0, ["questionModel"]);
var Radio = class extends Question {
  getValue() {
    return this.state.options.filter(({ checked }) => Boolean(checked)).map(({ id }) => id);
  }
  setValue(value) {
    this.state.options.forEach((option) => {
      option.checked = String(option.id) === String(value);
    });
    this.validate();
  }
  resetValue() {
    this.state.options.forEach((option) => {
      option.checked = false;
    });
    this.validate();
  }
  getAnswerText() {
    return this.state.options.filter(({ checked }) => Boolean(checked)).map(({ id, label }) => label || id).join(", ");
  }
  getValueAsObj() {
    return { options: this.getValue() };
  }
  validate() {
    const isRequired = this.state.required;
    const errors = [];
    this.state.errors = errors;
    this.state.isValid = true;
    if (isRequired) {
      const values = this.getValue();
      if (values.length < 1) {
        errors.push(i18n3(["requiredField"]));
        this.state.isValid = false;
        return errors;
      }
    }
    return null;
  }
  updateStateFromPreviousState(previousState) {
    const checkedOptions = [];
    super.updateStateFromPreviousState(previousState);
    previousState.options.forEach(({ id, checked }) => {
      if (checked) {
        checkedOptions.push(id);
      }
    });
    this.state.options.forEach((option) => {
      if (checkedOptions.includes(option.id)) {
        option.checked = true;
      }
    });
  }
  normalize() {
    if (!this.state.options) {
      this.state.options = [];
    }
    return super.normalize();
  }
};

// src/question-model/utils.ts
function updateSpecialOptions(model, previousState) {
  const { state: {
    noAnswer,
    noOpinionAnswer,
    otherAnswer,
    otherAnswerWithText
  } } = model;
  const {
    noAnswer: prevNoAnswer,
    noOpinionAnswer: prevNoOpinionAnswer,
    otherAnswer: prevOtherAnswer,
    otherAnswerWithText: prevOtherAnswerWithText
  } = previousState;
  if (noAnswer) {
    const _a = prevNoAnswer, { label } = _a, stateFields = _chunkQ4G2SZRDjs.__objRest.call(void 0, _a, ["label"]);
    Object.assign(noAnswer, stateFields);
  }
  if (noOpinionAnswer) {
    const _b = prevNoOpinionAnswer, { label } = _b, stateFields = _chunkQ4G2SZRDjs.__objRest.call(void 0, _b, ["label"]);
    Object.assign(noOpinionAnswer, stateFields);
  }
  if (otherAnswer) {
    const _c = prevOtherAnswer, { label } = _c, stateFields = _chunkQ4G2SZRDjs.__objRest.call(void 0, _c, ["label"]);
    Object.assign(otherAnswer, stateFields);
  }
  if (otherAnswerWithText) {
    const _d = prevOtherAnswerWithText, { label } = _d, stateFields = _chunkQ4G2SZRDjs.__objRest.call(void 0, _d, ["label"]);
    Object.assign(otherAnswerWithText, stateFields);
  }
}

// src/question-model/types/choice.ts
var i18n4 = _chunkR624SQFFjs.i18n.call(void 0, ["questionModel"]);
var additionalAnswers = {
  NO_ANSWER: -1,
  NO_OPINION_ANSWER: -2,
  OTHER_ANSWER: -3,
  OTHER_ANSWER_WITH_TEXT: -4,
  QUESTION_SHOWN: -5
};
var Choice = class extends Radio {
  setValue(value) {
    const { state } = this;
    const { multipleChoice } = state;
    const { options } = state;
    const otherAnswer = state.otherAnswer || {};
    state.errors = [];
    if (multipleChoice) {
      options.forEach((option) => {
        if (String(option.id) === String(value)) {
          option.checked = !option.checked;
        }
      });
    } else {
      options.forEach((option) => {
        otherAnswer.checked = false;
        option.checked = String(option.id) === String(value);
      });
      if (state.otherAnswer) {
        state.otherAnswer.checked = false;
      }
      if (state.otherAnswerWithText) {
        state.otherAnswerWithText.checked = false;
      }
    }
    if (state.noAnswer) {
      state.noAnswer.checked = false;
    }
    if (state.noOpinionAnswer) {
      state.noOpinionAnswer.checked = false;
    }
    this.validate();
  }
  getValue() {
    if (this.state.noAnswer && this.state.noAnswer.checked) {
      return [additionalAnswers.NO_ANSWER];
    }
    if (this.state.noOpinionAnswer && this.state.noOpinionAnswer.checked) {
      return [additionalAnswers.NO_OPINION_ANSWER];
    }
    const ids = this.state.options.filter(({ checked }) => Boolean(checked)).map(({ id }) => id);
    if (this.state.otherAnswer && this.state.otherAnswer.checked) {
      ids.push(additionalAnswers.OTHER_ANSWER);
    }
    if (this.state.otherAnswerWithText && this.state.otherAnswerWithText.checked) {
      ids.push(additionalAnswers.OTHER_ANSWER_WITH_TEXT);
    }
    if (this.state.options.length === 1 && !ids.length) {
      return [additionalAnswers.QUESTION_SHOWN];
    }
    return ids;
  }
  getOtherWithTextValue() {
    const { state } = this;
    const otherAnswerWithText = state.otherAnswerWithText || {};
    if (otherAnswerWithText.checked) {
      return otherAnswerWithText.value || "";
    }
    return "";
  }
  // @ts-ignore
  getValueAsObj() {
    const value = this.getValue();
    const otherValue = this.getOtherWithTextValue();
    const commonValue = {};
    commonValue.options = value || [];
    commonValue.text = otherValue || "";
    return commonValue;
  }
  mapOverAnswerLabels(fn) {
    if (this.state.noAnswer) {
      this.state.noAnswer.label = fn(this.state.noAnswer.label);
    }
    if (this.state.noOpinionAnswer) {
      this.state.noOpinionAnswer.label = fn(this.state.noOpinionAnswer.label);
    }
    this.state.options.forEach((option) => {
      option.label = fn(option.label);
      return option;
    });
    if (this.state.otherAnswer) {
      this.state.otherAnswer.label = fn(this.state.otherAnswer.label);
    }
    if (this.state.otherAnswerWithText) {
      this.state.otherAnswerWithText.label = fn(this.state.otherAnswerWithText.label);
    }
  }
  getAnswerText() {
    if (this.state.noAnswer && this.state.noAnswer.checked) {
      return this.state.noAnswer.label;
    }
    if (this.state.noOpinionAnswer && this.state.noOpinionAnswer.checked) {
      return this.state.noOpinionAnswer.label;
    }
    const labels = this.state.options.filter(({ checked }) => Boolean(checked)).map(({ label }) => label);
    if (this.state.otherAnswer && this.state.otherAnswer.checked) {
      labels.push(this.state.otherAnswer.label);
    }
    if (this.state.otherAnswerWithText && this.state.otherAnswerWithText.checked && this.state.otherAnswerWithText.value !== void 0) {
      labels.push(this.state.otherAnswerWithText.value);
    }
    return labels.join(", ");
  }
  setOtherWithTextValue(value) {
    if (!this.state.otherAnswerWithText) {
      return;
    }
    this.state.otherAnswerWithText.value = value;
    this.validate();
  }
  resetValue() {
    this.state.options.forEach((option) => {
      option.checked = false;
    });
    if (this.state.noAnswer) {
      this.state.noAnswer.checked = false;
    }
    if (this.state.noOpinionAnswer) {
      this.state.noOpinionAnswer.checked = false;
    }
    if (this.state.otherAnswer) {
      this.state.otherAnswer.checked = false;
    }
    if (this.state.otherAnswerWithText) {
      this.state.otherAnswerWithText.checked = false;
      this.state.otherAnswerWithText.value = "";
    }
    this.validate();
  }
  toggleOther() {
    const { state } = this;
    const { multipleChoice } = state;
    const { options } = state;
    const otherAnswer = state.otherAnswer || {};
    if (multipleChoice) {
      otherAnswer.checked = !otherAnswer.checked;
    } else {
      options.forEach((option) => {
        option.checked = false;
      });
      otherAnswer.checked = true;
      if (otherAnswer.checked && state.otherAnswerWithText) {
        state.otherAnswerWithText.checked = false;
      }
    }
    if (otherAnswer.checked && state.noAnswer) {
      state.noAnswer.checked = false;
    }
    if (otherAnswer.checked && state.noOpinionAnswer) {
      state.noOpinionAnswer.checked = false;
    }
    state.otherAnswer = otherAnswer;
    this.validate();
  }
  toggleOtherWithText() {
    const { state } = this;
    const { multipleChoice } = state;
    const { options } = state;
    const otherAnswerWithText = state.otherAnswerWithText || {};
    if (multipleChoice) {
      otherAnswerWithText.checked = !otherAnswerWithText.checked;
    } else {
      options.forEach((option) => {
        option.checked = false;
      });
      otherAnswerWithText.checked = true;
      if (otherAnswerWithText.checked && state.otherAnswer) {
        state.otherAnswer.checked = false;
      }
    }
    if (otherAnswerWithText.checked && state.noAnswer) {
      state.noAnswer.checked = false;
    }
    if (otherAnswerWithText.checked && state.noOpinionAnswer) {
      state.noOpinionAnswer.checked = false;
    }
    state.otherAnswerWithText = otherAnswerWithText;
    this.validate();
  }
  toggleNoAnswer() {
    const { state } = this;
    const { options, multipleChoice } = state;
    const noAnswer = state.noAnswer || {};
    if (multipleChoice) {
      noAnswer.checked = !noAnswer.checked;
    } else {
      noAnswer.checked = true;
    }
    if (noAnswer.checked) {
      options.forEach((option) => {
        option.checked = false;
      });
      if (state.otherAnswer) {
        state.otherAnswer.checked = false;
      }
      if (state.otherAnswerWithText) {
        state.otherAnswerWithText.checked = false;
      }
      if (state.noOpinionAnswer) {
        state.noOpinionAnswer.checked = false;
      }
    }
    state.noAnswer = noAnswer;
    this.validate();
  }
  toggleNoOpinionAnswer() {
    const { state } = this;
    const { options, multipleChoice } = state;
    const noOpinionAnswer = state.noOpinionAnswer || {};
    if (multipleChoice) {
      noOpinionAnswer.checked = !noOpinionAnswer.checked;
    } else {
      noOpinionAnswer.checked = true;
    }
    if (noOpinionAnswer.checked) {
      options.forEach((option) => {
        option.checked = false;
      });
      if (state.otherAnswer) {
        state.otherAnswer.checked = false;
      }
      if (state.otherAnswerWithText) {
        state.otherAnswerWithText.checked = false;
      }
      if (state.noAnswer) {
        state.noAnswer.checked = false;
      }
    }
    state.noOpinionAnswer = noOpinionAnswer;
    this.validate();
  }
  validate() {
    const isRequired = this.state.required;
    const { maxAnswerCount, charLimit, minAnswerCount } = this.state;
    this.state.errors = [];
    this.state.isValid = true;
    const values = this.getValue().filter((value) => value !== additionalAnswers.QUESTION_SHOWN);
    const otherValue = this.getOtherWithTextValue().trim();
    if (isRequired) {
      if (values.length < 1 && !otherValue) {
        const error = i18n4(["requiredField"]);
        this.state.errors.push(error);
        this.state.isValid = false;
      }
    }
    if (values.indexOf(-4) >= 0) {
      if (!otherValue) {
        this.state.errors.push(i18n4(["notFilled"]));
        this.state.isValid = false;
      } else if (charLimit && otherValue.length > charLimit) {
        this.state.errors.push(i18n4(["maxLenghtExceeded"]));
        this.state.isValid = false;
      }
    }
    if (minAnswerCount && values.length < minAnswerCount) {
      if (!values.includes(additionalAnswers.NO_ANSWER) && !values.includes(additionalAnswers.NO_OPINION_ANSWER)) {
        const error = i18n4(["insufficientAnswers"], minAnswerCount).replace(
          "%s",
          minAnswerCount.toString()
        );
        this.state.errors.push(error);
        this.state.isValid = false;
      }
    }
    if (maxAnswerCount && values.length > maxAnswerCount) {
      const error = i18n4(["tooManyAnswers"], maxAnswerCount).replace(
        "%s",
        maxAnswerCount.toString()
      );
      this.state.errors.push(error);
      this.state.isValid = false;
    }
    return this.state.errors.length === 0 ? null : this.state.errors;
  }
  updateStateFromPreviousState(previousState) {
    super.updateStateFromPreviousState(previousState);
    updateSpecialOptions(this, previousState);
  }
};

// src/question-model/types/email.ts
var _isEmail = require('validator/lib/isEmail'); var _isEmail2 = _interopRequireDefault(_isEmail);
var i18n5 = _chunkR624SQFFjs.i18n.call(void 0, ["questionModel"]);
var Email = class extends Text {
  validate() {
    super.validate();
    const value = this.getValue().trim();
    const { errors } = this.state || [];
    const { required } = this.state;
    if (required || value) {
      if (!_isEmail2.default.call(void 0, value)) {
        errors.push(i18n5(["notEmail"]));
      }
    }
    if (errors.length > 0) {
      this.state.isValid = false;
      return errors;
    }
    return null;
  }
};

// src/question-model/types/rating.ts
var Rating = class extends Choice {
  // у рейтинга нет лейблов с вариантами ответа
  getAnswerText() {
    if (this.state.noOpinionAnswer && this.state.noOpinionAnswer.checked) {
      return this.state.noOpinionAnswer.label;
    }
    if (this.state.otherAnswer && this.state.otherAnswer.checked) {
      return this.state.otherAnswer.label;
    }
    if (this.state.otherAnswerWithText && this.state.otherAnswerWithText.checked) {
      return this.state.otherAnswerWithText.label;
    }
    const ids = this.state.options.filter(({ checked }) => Boolean(checked)).map(({ id }) => id);
    return ids.join(", ");
  }
  normalize() {
    const { state } = this;
    if (!state.options) {
      let maxValue = Number(state.maxValue);
      if (isNaN(maxValue)) {
        maxValue = 0;
      }
      if (maxValue > 10) {
        maxValue = 10;
      }
      state.options = [];
      for (let i = 1; i <= maxValue; i = i + 1) {
        state.options.push({ id: i });
      }
    }
    return super.normalize();
  }
};

// src/question-model/types/number.ts
var _isDecimal = require('validator/lib/isDecimal'); var _isDecimal2 = _interopRequireDefault(_isDecimal);
var i18n6 = _chunkR624SQFFjs.i18n.call(void 0, ["questionModel"]);
var Number2 = class extends Text {
  // eslint-disable-next-line max-statements
  validate() {
    super.validate();
    const value = this.getValue();
    const { errors } = this.state || [];
    const { required, maxValue, minValue } = this.state;
    if (required || value || parseFloat(value) === 0) {
      if (!_isDecimal2.default.call(void 0, value)) {
        errors.push(i18n6(["notNumber"]));
      } else if (typeof maxValue === "number" && maxValue < value) {
        errors.push(i18n6(["moreThan"]).replace("%s", maxValue));
      } else if (typeof minValue === "number" && minValue > value) {
        errors.push(i18n6(["lessThan"]).replace("%s", minValue));
      }
    }
    if (errors.length > 0) {
      this.state.isValid = false;
      return errors;
    }
    return null;
  }
};

// src/question-model/types/scale.ts
var Scale = class extends Choice {
  getAnswerText() {
    if (this.state.noOpinionAnswer && this.state.noOpinionAnswer.checked) {
      return this.state.noOpinionAnswer.label;
    }
    if (this.state.otherAnswer && this.state.otherAnswer.checked) {
      return this.state.otherAnswer.label;
    }
    if (this.state.otherAnswerWithText && this.state.otherAnswerWithText.checked) {
      return this.state.otherAnswerWithText.label;
    }
    const ids = this.state.options.filter(({ checked }) => Boolean(checked)).map(({ id }) => id);
    return ids.join(", ");
  }
  // eslint-disable-next-line max-statements
  normalize() {
    const { state } = this;
    if (!state.options) {
      let maxValue = Number(state.maxValue);
      let minValue = Number(state.minValue);
      if (isNaN(maxValue)) {
        maxValue = 0;
      }
      if (isNaN(minValue)) {
        minValue = 1;
      }
      if (maxValue > 10) {
        maxValue = 10;
      }
      if (minValue < 0) {
        minValue = 0;
      }
      state.options = [];
      for (let i = minValue; i <= maxValue; i = i + 1) {
        state.options.push({ id: i });
      }
      state.options.sort((a, b) => a.id - b.id);
    }
    return super.normalize();
  }
};

// src/question-model/types/emotion.ts
var i18n7 = _chunkR624SQFFjs.i18n.call(void 0, ["questionModel"]);
var EMOTIONS_SET = {
  2: [1, 5],
  3: [1, 3, 5],
  5: [1, 2, 3, 4, 5]
};
var Emotion = class extends Choice {
  get labels() {
    if (!this._labels) {
      this._labels = [
        i18n7(["awful"]),
        i18n7(["bad"]),
        i18n7(["normally"]),
        i18n7(["well"]),
        i18n7(["perfectly"])
      ];
    }
    return this._labels;
  }
  getAnswerText() {
    if (this.state.noOpinionAnswer && this.state.noOpinionAnswer.checked) {
      return this.state.noOpinionAnswer.label;
    }
    if (this.state.otherAnswer && this.state.otherAnswer.checked) {
      return this.state.otherAnswer.label;
    }
    if (this.state.otherAnswerWithText && this.state.otherAnswerWithText.checked) {
      return this.state.otherAnswerWithText.label;
    }
    const id = this.getValue();
    return this.labels[id - 1] || "";
  }
  normalize() {
    const { state } = this;
    if (!state.options) {
      let optionsCount = Number(state.optionsCount);
      if (isNaN(optionsCount)) {
        optionsCount = 5;
      }
      if (optionsCount > 5) {
        optionsCount = 5;
      }
      state.options = [];
      EMOTIONS_SET[optionsCount].forEach((id) => {
        state.options.push({ id, label: this.labels[id - 1] });
      });
    }
    return super.normalize();
  }
};

// src/question-model/types/extended-radio.ts
var ExtendedRadio = class extends Radio {
  setValue(value) {
    const { state } = this;
    const { options } = state;
    state.errors = [];
    options.forEach((option) => {
      option.checked = String(option.id) === String(value);
    });
    if (state.noOpinionAnswer) {
      state.noOpinionAnswer.checked = false;
    }
    this.validate();
  }
  getValue() {
    if (this.state.noOpinionAnswer && this.state.noOpinionAnswer.checked) {
      return [-2];
    }
    return this.state.options.filter(({ checked }) => Boolean(checked)).map(({ id }) => id);
  }
  resetValue() {
    if (this.state.noOpinionAnswer) {
      this.state.noOpinionAnswer.checked = false;
    }
    super.resetValue();
  }
  toggleNoOpinionAnswer() {
    const { state } = this;
    const { options } = state;
    const noOpinionAnswer = state.noOpinionAnswer || {};
    noOpinionAnswer.checked = true;
    options.forEach((option) => {
      option.checked = false;
    });
    state.noOpinionAnswer = noOpinionAnswer;
    this.validate();
  }
  updateStateFromPreviousState(previousState) {
    super.updateStateFromPreviousState(previousState);
    updateSpecialOptions(this, previousState);
  }
};

// src/question-model/types/sidebyside.ts
var i18n8 = _chunkR624SQFFjs.i18n.call(void 0, ["questionModel"]);
var SideBySide = class extends ExtendedRadio {
  setValue(value) {
    const { state } = this;
    const { options } = state;
    state.errors = [];
    options.forEach((option) => {
      option.checked = String(option.id) === String(value);
    });
    if (state.noAnswer) {
      state.noAnswer.checked = false;
    }
    if (state.noOpinionAnswer) {
      state.noOpinionAnswer.checked = false;
    }
    this.validate();
  }
  getValue() {
    if (this.state.noAnswer && this.state.noAnswer.checked) {
      return [-1];
    }
    if (this.state.noOpinionAnswer && this.state.noOpinionAnswer.checked) {
      return [-2];
    }
    return this.state.options.filter(({ checked }) => Boolean(checked)).map(({ id }) => id);
  }
  toggleNoAnswer() {
    const { state } = this;
    const { options } = state;
    const noAnswer = state.noAnswer || {};
    noAnswer.checked = true;
    if (noAnswer.checked) {
      options.forEach((option) => {
        option.checked = false;
      });
      if (state.noOpinionAnswer) {
        state.noOpinionAnswer.checked = false;
      }
    }
    state.noAnswer = noAnswer;
    this.validate();
  }
  toggleNoOpinionAnswer() {
    const { state } = this;
    const { options } = state;
    const noOpinionAnswer = state.noOpinionAnswer || {};
    noOpinionAnswer.checked = true;
    if (noOpinionAnswer.checked) {
      options.forEach((option) => {
        option.checked = false;
      });
      if (state.noAnswer) {
        state.noAnswer.checked = false;
      }
    }
    state.noOpinionAnswer = noOpinionAnswer;
    this.validate();
  }
  normalize() {
    const { state } = this;
    const { options } = state;
    options.forEach((option, index) => {
      option.label = option.label || i18n8(["picture"]).replace("%s", index + 1);
    });
    return super.normalize();
  }
};

// src/question-model/types/text-array.ts
var i18n9 = _chunkR624SQFFjs.i18n.call(void 0, ["questionModel"]);
var TextArray = class extends Question {
  getValue() {
    return this.state.value || [];
  }
  setValue(value) {
    this.state.value = value;
    this.validate();
  }
  pushValue(value) {
    const oldValue = this.getValue();
    this.setValue(oldValue.concat(value));
  }
  resetValue() {
    this.state.value = [];
    this.validate();
  }
  getAnswerText() {
    return JSON.stringify(this.state.value);
  }
  getValueAsObj() {
    return { text: this.getAnswerText() };
  }
  validate() {
    const isRequired = this.state.required;
    const errors = [];
    this.state.errors = errors;
    this.state.isValid = true;
    if (isRequired) {
      const value = this.getValue();
      if (value.length < 1) {
        errors.push(i18n9(["requiredField"]));
        this.state.isValid = false;
        return errors;
      }
    }
    return null;
  }
  updateStateFromPreviousState(previousState) {
    this.state.value = previousState.value;
  }
};

// src/question-model/types/date.ts
var i18n10 = _chunkR624SQFFjs.i18n.call(void 0, ["questionModel"]);
var DateQuestion = class extends Text {
  // eslint-disable-next-line max-statements
  validate() {
    super.validate();
    const { state } = this;
    const { range } = state;
    const value = this.getValue().trim();
    if (value && Number.isNaN(Date.parse(value))) {
      const error = i18n10(["notDate"]);
      state.errors.push(error);
      state.isValid = false;
      return state.errors;
    }
    if (range == null ? void 0 : range.enabled) {
      if ((range == null ? void 0 : range.minDate) && Date.parse(value) < Date.parse(range.minDate)) {
        const error = i18n10(["dateLessThan"]).replace(
          "%s",
          range.minDate.split("-").reverse().join(".")
        );
        state.errors.push(error);
        state.isValid = false;
      }
      if ((range == null ? void 0 : range.maxDate) && Date.parse(value) > Date.parse(range.maxDate)) {
        const error = i18n10(["dateMoreThan"]).replace(
          "%s",
          range.maxDate.split("-").reverse().join(".")
        );
        state.errors.push(error);
        state.isValid = false;
      }
      return state.errors;
    }
    return null;
  }
};

// src/question-model/types/table-question.ts
var i18n11 = _chunkR624SQFFjs.i18n.call(void 0, ["questionModel"]);
var TableQuestion = class extends Question {
  getValueAsObj() {
    return { text: this.getAnswerText() };
  }
  getValue() {
    const value = {};
    for (const key of Object.keys(this.state.boundQuestionsRevision || {})) {
      const currentQuestion = this.state.boundQuestionsRevision[key];
      if (currentQuestion.visible) {
        const ids = currentQuestion.options.filter(({ checked }) => Boolean(checked)).map(({ id }) => id);
        value[key] = { ids, isValid: currentQuestion.isValid };
      }
    }
    return value;
  }
  setValue() {
    this.state.value = this.getValue();
    this.validate();
  }
  resetValue() {
    this.state.value = {};
    this.validate();
  }
  getAnswerText() {
    return JSON.stringify(this.getValue());
  }
  // eslint-disable-next-line max-statements, complexity
  validate() {
    var _a, _b;
    const isRequired = this.state.required;
    const { maxAnswerCountPerRow, multipleChoice } = this.state;
    this.state.errors = [];
    this.state.isValid = true;
    const value = this.getValue();
    if (isRequired || maxAnswerCountPerRow && multipleChoice) {
      for (const key of Object.keys(value)) {
        if (maxAnswerCountPerRow && ((_b = (_a = value[key]) == null ? void 0 : _a.ids) == null ? void 0 : _b.length) > maxAnswerCountPerRow) {
          const error = i18n11(["maxAnswerPerRowExceeded"]);
          this.state.errors.push(error);
          this.state.isValid = false;
          break;
        }
        if (value[key] && !value[key].isValid) {
          const error = i18n11(["requiredField"]);
          this.state.errors.push(error);
          this.state.isValid = false;
          break;
        }
      }
    }
    return this.state.errors.length === 0 ? null : this.state.errors;
  }
};

// src/question-model/types/table-scale-question.ts
var TableScaleQuestion = class extends TableQuestion {
  getValue() {
    var _a;
    const value = {};
    for (const key of Object.keys(this.state.boundQuestionsRevision || {})) {
      const currentQuestion = this.state.boundQuestionsRevision[key];
      if (!currentQuestion.visible) {
        continue;
      }
      if (currentQuestion.noOpinionAnswer.checked) {
        value[key] = { ids: [], isValid: true };
      } else {
        const ids = (_a = currentQuestion.options) == null ? void 0 : _a.filter(({ checked }) => Boolean(checked)).map(({ id }) => id);
        value[key] = { ids, isValid: currentQuestion.isValid };
      }
    }
    return value;
  }
};

// src/question-model/types/geo-text.ts
var i18n12 = _chunkR624SQFFjs.i18n.call(void 0, ["questionModel"]);
var GeoText = class extends Text {
  setValue(value) {
    this.state.value = value;
    if (this.state.otherAnswer) {
      this.state.otherAnswer.checked = false;
    }
    if (this.state.otherAnswerWithText) {
      this.state.otherAnswerWithText.checked = false;
    }
    if (this.state.noOpinionAnswer) {
      this.state.noOpinionAnswer.checked = false;
    }
    this.validate();
  }
  setOtherWithTextValue(value) {
    if (!this.state.otherAnswerWithText) {
      return;
    }
    this.state.otherAnswerWithText.value = value;
    this.validate();
  }
  getValue() {
    if (this.state.noOpinionAnswer && this.state.noOpinionAnswer.checked) {
      return [additionalAnswers.NO_OPINION_ANSWER];
    }
    if (this.state.otherAnswer && this.state.otherAnswer.checked) {
      return [additionalAnswers.OTHER_ANSWER];
    }
    if (this.state.otherAnswerWithText && this.state.otherAnswerWithText.checked) {
      return [additionalAnswers.OTHER_ANSWER_WITH_TEXT];
    }
    return this.state.value || "";
  }
  // @ts-ignore
  getValueAsObj() {
    const { state } = this;
    const value = this.getValue();
    const otherValue = this.getOtherWithTextValue();
    const commonValue = {};
    commonValue.options = Array.isArray(value) ? value : [];
    commonValue.text = typeof value === "string" ? value : "";
    if (state.otherAnswerWithText && state.otherAnswerWithText.checked) {
      commonValue.text = otherValue || "";
    }
    return commonValue;
  }
  getOtherWithTextValue() {
    const { state } = this;
    const otherAnswerWithText = state.otherAnswerWithText || {};
    if (otherAnswerWithText.checked) {
      return otherAnswerWithText.value || "";
    }
    return "";
  }
  getAnswerText() {
    if (this.state.noOpinionAnswer && this.state.noOpinionAnswer.checked) {
      return this.state.noOpinionAnswer.label;
    }
    if (this.state.otherAnswer && this.state.otherAnswer.checked) {
      return this.state.otherAnswer.label;
    }
    if (this.state.otherAnswerWithText && this.state.otherAnswerWithText.checked && this.state.otherAnswerWithText.value !== void 0) {
      return this.state.otherAnswerWithText.value;
    }
    return this.state.value;
  }
  // eslint-disable-next-line max-statements,complexity
  validate() {
    const isRequired = this.state.required;
    const { state } = this;
    state.errors = [];
    state.isValid = true;
    if (isRequired && this.state.otherAnswerWithText && this.state.otherAnswerWithText.checked && !this.state.otherAnswerWithText.value) {
      state.errors.push(i18n12(["notFilled"]));
      state.isValid = false;
      return state.errors;
    }
    const value = this.getValue();
    if (Array.isArray(value)) {
      if (isRequired && !value.length) {
        state.errors.push(i18n12(["requiredField"]));
        state.isValid = false;
        return state.errors;
      }
    } else {
      const textValue = this.getValue().trim();
      if (isRequired && !textValue) {
        state.errors.push(i18n12(["requiredField"]));
        state.isValid = false;
        return state.errors;
      }
      return null;
    }
  }
  toggleNoOpinionAnswer() {
    const { state } = this;
    const noOpinionAnswer = state.noOpinionAnswer || {};
    noOpinionAnswer.checked = true;
    if (noOpinionAnswer.checked) {
      this.state.value = "";
      if (state.otherAnswer) {
        state.otherAnswer.checked = false;
      }
      if (state.otherAnswerWithText) {
        state.otherAnswerWithText.checked = false;
      }
    }
    state.noOpinionAnswer = noOpinionAnswer;
    this.validate();
  }
  toggleOther() {
    const { state } = this;
    const otherAnswer = state.otherAnswer || {};
    otherAnswer.checked = true;
    if (otherAnswer.checked) {
      this.state.value = "";
      if (state.noOpinionAnswer) {
        state.noOpinionAnswer.checked = false;
      }
      if (state.otherAnswerWithText) {
        state.otherAnswerWithText.checked = false;
      }
    }
    state.otherAnswer = otherAnswer;
    this.validate();
  }
  toggleOtherWithText() {
    const { state } = this;
    const otherAnswerWithText = state.otherAnswerWithText || {};
    otherAnswerWithText.checked = true;
    if (otherAnswerWithText.checked) {
      this.state.value = "";
      if (state.noOpinionAnswer) {
        state.noOpinionAnswer.checked = false;
      }
      if (state.otherAnswer) {
        state.otherAnswer.checked = false;
      }
    }
    state.otherAnswerWithText = otherAnswerWithText;
    this.validate();
  }
  resetValue() {
    this.state.value = "";
    if (this.state.noOpinionAnswer) {
      this.state.noOpinionAnswer.checked = false;
    }
    if (this.state.otherAnswer) {
      this.state.otherAnswer.checked = false;
    }
    if (this.state.otherAnswerWithText) {
      this.state.otherAnswerWithText.checked = false;
      this.state.otherAnswerWithText.value = "";
    }
    this.validate();
  }
};

// src/question-model/index.ts
var mapByConstructors = {
  shortText: Text,
  longText: Text,
  geoText: GeoText,
  email: Email,
  number: Number2,
  rating: Rating,
  sidebyside: SideBySide,
  emotion: Emotion,
  scale: Scale,
  choice: Choice,
  ux: TextArray,
  clickmapVideo: TextArray,
  date: DateQuestion,
  table: TableQuestion,
  tableScale: TableScaleQuestion
};
function Question2(state, previousState = void 0) {
  const { type } = state;
  const Constructor = mapByConstructors[type];
  if (!Constructor) {
    throw new Error(`Unknown type question type: ${type}`);
  }
  return new Constructor(state, previousState);
}



exports.Question = Question2;
//# sourceMappingURL=chunk-LJDPNQT6.js.map